__turbopack_context__.v({
  "arrow": "announcement-banner-module-scss-module__WnXXLG__arrow",
  "banner": "announcement-banner-module-scss-module__WnXXLG__banner",
  "cta": "announcement-banner-module-scss-module__WnXXLG__cta",
  "inner": "announcement-banner-module-scss-module__WnXXLG__inner",
  "text": "announcement-banner-module-scss-module__WnXXLG__text",
});
